import { render } from "./DriverNewVoucher.vue?vue&type=template&id=6556d01f&scoped=true"
import script from "./DriverNewVoucher.vue?vue&type=script&lang=js"
export * from "./DriverNewVoucher.vue?vue&type=script&lang=js"

import "./DriverNewVoucher.vue?vue&type=style&index=0&id=6556d01f&scoped=true&lang=css"

import exportComponent from "C:\\SeaFarer\\SeaFarer\\AMDTransportation_FE\\amd_transportation_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6556d01f"]])

export default __exports__